import { Mark, markInputRule, markPasteRule, mergeAttributes } from '@tiptap/core'

export interface KbdOptions {
  HTMLAttributes: Record<string, any>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    kbd: {
      /**
       * Set a kbd mark
       */
      setKbd: () => ReturnType
      /**
       * Toggle a kbd mark
       */
      toggleKbd: () => ReturnType
      /**
       * Unset a kbd mark
       */
      unsetKbd: () => ReturnType
    }
  }
}

export const kbdInputRegex = /(?:^|\s)(`([^`]+)`)$/
export const kbdPasteRegex = /(?:^|\s?)(`([^`]+)`)/g

export const Kbd = Mark.create<KbdOptions>({
  name: 'kbd',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  excludes: '_',

  parseHTML() {
    return [
      {
        tag: 'kbd',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'kbd',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ]
  },

  addCommands() {
    return {
      setKbd:
        () =>
        ({ commands }) => {
          return commands.setMark(this.name)
        },
      toggleKbd:
        () =>
        ({ commands }) => {
          return commands.toggleMark(this.name)
        },
      unsetKbd:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name)
        },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Shift-k': () => this.editor.commands.toggleKbd(),
    }
  },

  addInputRules() {
    return [
      markInputRule({
        find: kbdInputRegex,
        type: this.type,
      }),
    ]
  },

  addPasteRules() {
    return [
      markPasteRule({
        find: kbdPasteRegex,
        type: this.type,
      }),
    ]
  },
})